import moment from "moment";
import { Text } from "@chakra-ui/react";

interface IRangeDateProps {
  start_date: string;
  due_date: string;
}

const toDate = (date: string): moment.Moment => {
  if (date.trim().length === 10) {
    return moment(date, "YYYY-MM-DD");
  } else {
    return moment(date);
  }
};

const RangeDate = ({ start_date, due_date }: IRangeDateProps) => {
  if (!start_date || !due_date) return null;

  const startMoment = toDate(start_date);
  const dueMoment = toDate(due_date);
  const formattedStart = startMoment.format("MMM DD");
  const formattedDue = startMoment.isSame(dueMoment, "month")
    ? dueMoment.format("DD")
    : dueMoment.format("MMM DD");

  const isDueDateGreaterThanToday = moment().isAfter(dueMoment);

  return <Text color={isDueDateGreaterThanToday ? "red.400" : "#6C6B6E"} fontSize="12px">{`${formattedStart} - ${formattedDue}`}</Text>;
};

export default RangeDate;